// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseResourceMetadataMessage } from './genericApiResponseResourceMetadataMessage';
import type { GenericApiResponseResourceMetadataPagination } from './genericApiResponseResourceMetadataPagination';
import type { GenericApiResponseResourceMetadataData } from './genericApiResponseResourceMetadataData';

export interface GenericApiResponseResourceMetadata {
  success?: boolean;
  message?: GenericApiResponseResourceMetadataMessage;
  pagination?: GenericApiResponseResourceMetadataPagination;
  data?: GenericApiResponseResourceMetadataData;
}
